<template>
  <div>
    <div class="bottom-box">
      <cardTitle title="资质证书" class="mb-10px" />
      <el-scrollbar
        ref="scrollContainer"
        @wheel.native.prevent="handleScroll"
        @mouseenter.native="mouseBtn('moveIn')"
        @mouseleave.native="mouseBtn('remove')">
        <div class="inline-flex">
          <div class="cert-item w-110px h-150px mr-30px cursor-pointer" v-for="item in certList" :key="item.img" @click="imgHandle(item.img)">
            <img :src="item.img" alt="" class="w-full h-full"/>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="baseImageList"
    ></el-image>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'

export default {
  name: 'CertList',
  components: {
    CardTitle
  },
  data() {
    return {
      certList: [
        { img: require('./image/cert/cert1.png') },
        { img: require('./image/cert/cert2.png') },
        { img: require('./image/cert/cert3.png') },
        { img: require('./image/cert/cert4.png') },
        { img: require('./image/cert/cert5.png') },
        { img: require('./image/cert/cert6.png') },
        { img: require('./image/cert/cert7.png') },
        { img: require('./image/cert/cert8.png') },
      ],
      imgContent: '',
      baseImageList: [],
      scrollDirection: 'right', // 滚动方向 left向左 right向右
      scrollTimer: null,
    }
  },
  methods: {
    autoScroll() {
      const dom = this.$refs.scrollContainer?.$refs?.wrap
      if (dom) {
        const scrollWidth = dom.scrollWidth
        const clientWidth = dom.clientWidth
        if (scrollWidth - clientWidth <= 0) return
        this.scrollFun()
      }
    },
    scrollFun() {
      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        const dom = this.$refs.scrollContainer?.$refs?.wrap
        if (!dom) {
          clearInterval(this.scrollTimer)
          return
        }
        const scrollWidth = dom.scrollWidth
        const clientWidth = dom.clientWidth
        const scrollLeft = dom.scrollLeft
        // 向右滚动
        if (this.scrollDirection === 'right') {
          dom.scrollLeft = scrollLeft + 1
          if (scrollWidth - clientWidth <= scrollLeft + 1) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'left'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
          // 向左滚动
        } else if (this.scrollDirection === 'left') {
          dom.scrollLeft = scrollLeft - 1
          if (scrollLeft - 1 <= 0) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'right'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
        }
      }, 150)
    },
    mouseBtn(type) {
      if (type === 'moveIn') {
        this.stopScroll()
      } else if (type === 'remove') {
        this.autoScroll()
      }
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    handleScroll(e) {
      const eventData = e.wheelDelta || -e.deltaY * 40
      this.$refs.scrollContainer.$refs.wrap.scrollLeft =
        this.$refs.scrollContainer.$refs.wrap.scrollLeft + eventData / 4
    },
    imgHandle(img) {
      this.imgContent = img
      this.baseImageList = this.certList.map((item) => {
        return item.img
      })
      this.$nextTick(() => {
        this.$refs.elImage.clickHandler()
      })
    },
  },
  mounted() {
    setTimeout(() => {
      this.autoScroll()
    }, 1000)
  },
  beforeDestroy() {
    this.stopScroll()
  }
}
</script>

<style lang="scss" scoped>
.bottom-box {
  position: fixed;
  bottom: 20px;
  left: 480px;
  right: 480px;
  height: 240px;
  background: #103a44b2;
  border: 1px solid #44f1ff4c;
  box-shadow: inset 0 0 142px 0 #06333d;
  padding: 10px;
  border-radius: 10px;
  .cert-item {
    flex-shrink: 0;
    padding: 6px 8px 10px;
    background-image: url('./image/tbg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    &:last-child {
      margin-right: 10px;
    }
  }
}
::v-deep {
  .el-scrollbar {
    background: none;
  }
}
</style>
